/**
 * @author Fernando Tapia <ftapia@pensare.mx>
 * @version 1.0.0
 * @file Manages data util about gis client container
 */


import React, {Component} from 'react';
import ol from 'openlayers';
import * as MapUtil from '../utils/map.js';
import featureToolImage from '../resources/images/maps/panel.svg';
import homeToolImage from '../resources/images/maps/home.svg';
import pinToolImage from '../resources/images/maps/pin.svg';
import printToolImage from '../resources/images/maps/print.svg';
import performanceToolImage from '../resources/images/maps/performance.svg';
import zoomInToolImage from '../resources/images/maps/zoom-in.svg';
import zoomOutToolImage from '../resources/images/maps/zoom-out.svg';
import layerImage from '../resources/images/maps/view-layer.svg';

require("openlayers/css/ol.css");

const format = 'image/png';

const epsg4326 = 'EPSG:4326';
const epsg3857 = 'EPSG:3857';
const zoomInit = 11;
var layerinfoswitcher = "";

class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      coordinate: null,
      layersNames: []
    }
  }

  componentDidMount() {
    this.state.coordinate = MapUtil.getLonLat(this.props.idBusinessUnit);
    let layersData = MapUtil.getLayers(this.props.idBusinessUnit);
    var scaleLineControl = new ol.control.ScaleLine();

    var mousePositionControl = new ol.control.MousePosition({
      coordinateFormat: ol.coordinate.createStringXY(4),
      projection: epsg4326,
      className: 'custom-mouse-position',
      target: document.getElementById('mouse-position'),
      undefinedHTML: '&nbsp;'
    });

    var view = new ol.View({
      center: ol.proj.fromLonLat([this.state.coordinate.lon, this.state.coordinate.lat]),
      zoom: zoomInit
    });

    this.state.map = new ol.Map({
      target: 'map',
      controls: ol.control.defaults({
        attributionOptions: {
          collapsible: false
        }
      }).extend([mousePositionControl, new ol.control.FullScreen(), scaleLineControl, mousePositionControl, new ol.control.ZoomSlider()]),
      layers: layersData,
      view: view
    });

    /*this.state.map.on('singleclick', function (evt) {
      document.getElementById('feature-info-id').classList.add('display-component-tool');
      document.getElementById('feature-info-id').innerHTML = '';
      var viewResolution = (view.getResolution());
      var url = '';
      layersData.forEach(function (layer, i, layers) {
        if (layer.getVisible() && layer.get('name') != 'baseMap') {
          url = layer.getSource().getGetFeatureInfoUrl(evt.coordinate, viewResolution, epsg3857, {
            'INFO_FORMAT': 'text/html'
          });
          if (url) {
            document.getElementById('feature-info-id').innerHTML +=
              '<iframe class="info-content-feature" seamless src="' + url + '"></iframe>';
          }
        }
      });
    });*/

    var layersInGroup;
    var ls = [];
    layersData.forEach(function (group, i, layers) {
      layersInGroup = group.getLayers();
      if (group.get("title") != "Base") {
        layersInGroup = group.getLayers();
        layersInGroup.forEach(function (layer, j, groups) {
          ls.push(layer.get('name'));
        })
      }
    });
    this.setState({layersNames: ls});
  }

  centerMap = () => {
    this.state.map.getView().animate({
      center: ol.proj.transform([this.state.coordinate.lon, this.state.coordinate.lat], epsg4326, epsg3857),
      duration: 2000,
      zoom: zoomInit
    });
  }

  featureInfo = () => {

  }

  layersProp() {
    return this.state.layersNames.map((layer) => {
      return (
        <div className='content-group' id={'layer-' + layer}>
          <img src={layerImage} title="Centrar" alt=" " className="img-layer"
               onClick={this.showLayer.bind(this, layer)}/>
          <span className='text-layer'>{layer}</span>
        </div>
      );
    });
  }

  showLayer = (name) => {
    var element = document.getElementById('layer-' + name);
    element.classList.toggle("class-opacity");
    var layerGroup = this.state.map.getLayers();
    var layersInGroup = null;
    layerGroup.forEach(function (group, i, layers) {
      layersInGroup = group.getLayers();
      if (group.get("title") != "Base") {
        layersInGroup = group.getLayers();
        layersInGroup.forEach(function (layer, j, gruups) {
          if (layer.get('name') === name) {
            layer.setVisible(!layer.getVisible());
          }
        })
      }
    });
  }

  showPanelLayers() {
    document.getElementById('id-layer-switcher').classList.toggle("layer-switcher-off");
    document.getElementById('map').classList.toggle("layer-map-on");
  }

  render() {
    return (
      <div>
        <div className='tool-bar-map'>
          <div className='tol-feature class-opacity'>
            <img src={zoomInToolImage} title="Zoom in" alt=" " className="img-tools"/>
          </div>
          <div className='tol-feature class-opacity'>
            <img src={zoomOutToolImage} title="Zoom out" alt=" " className="img-tools"/>
          </div>
          <div className='tol-feature class-opacity'>
            <img src={printToolImage} title="Imprimir" alt=" " className="img-tools"/>
          </div>
          <div className='tol-feature class-opacity'>
            <img src={pinToolImage} title="Información relacionada" alt=" " className="img-tools"/>
          </div>
          <div className='tol-feature class-opacity'>
            <img src={performanceToolImage} title="Medidas" alt=" " className="img-tools"/>
          </div>
          <div id='id-tol-left' className='tol-feature tol-feature-left' onClick={this.showPanelLayers}>
            <img src={featureToolImage} title="Ver información" alt=" " className="img-tools"/>
          </div>
          <div className='tol-feature' onClick={this.centerMap}>
            <img src={homeToolImage} title="Centrar" alt=" " className="img-tools"/>
          </div>
        </div>
        <div className="custom-mouse-position-map" id="mouse-position"></div>
        <div id='id-layer-switcher' className='layer-switcher'>
          <div className='title-group'>Capas de información</div>
          <div className='content-group'>{this.layersProp()}</div>
        </div>
        <div id="map" className="map-container"></div>
        <div id="feature-info-id" className="feature-info"></div>
      </div>
    )
  }
}

export default MapContainer;

/*<form>
  <label className="mr-1">Proyección: </label>
  <select id="projection">
    <option value="EPSG:4326">EPSG:4326</option>
    <option value="EPSG:3857">EPSG:3857</option>
  </select>
</form>*/



// WEBPACK FOOTER //
// ./src/containers/init-map.js